<template>
  <div id="curriculum-detail">
    <Head :headerNum="4" />
    <div class="content">
      <div class="content-wrap">
        <div class="c-detail block">
          <div class="head-title">课程详情</div>
          <div class="img-box">
            <img
              class="img-item"
              v-for="(item, index) in detailData[currentIndex - 1]"
              :key="index"
              :src="item"
              alt=""
            />
          </div>
        </div>
        <div class="c-right">
          <div v-if="!isPhone" class="c-consult block">
            <div class="head-title">咨询更多</div>
            <div class="consult-content">
              <img src="/static/img/wxcode-course.jpg?yt-v=202230426" alt="" />
              <div class="c-tip">报课及更多课程详情请扫码咨询课程顾问</div>
            </div>
          </div>
          <div class="c-recommend block">
            <div class="head-title">相关课程推荐</div>
            <div class="course-content">
              <div class="course-list list-2">
                <router-link
                  :to="{ path: '/curriculum-detail', query: { id: item.id } }"
                  class="c-item"
                  v-for="(item, index) in recommendData"
                  :key="index"
                >
                  <img :src="item.img" alt="" />
                  <div class="c-txt">
                    <div class="c-name">{{ item.name }}</div>
                    <div
                      class="c-title"
                      v-for="(item2, index2) in item.title"
                      :key="index2"
                    >
                      {{ item2 }}
                    </div>
                  </div>
                  <router-link
                    class="c-more"
                    :to="{ path: '/curriculum-detail' }"
                    >了解更多</router-link
                  >
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="consultShow" @click.self="consultShow = false" class="mask">
      <div class="pop">
        <div class="c-consult block">
          <div class="pop-title">咨询更多</div>
          <div class="consult-content">
            <img
              class="pop-wximg"
              src="/static/img/home-modal/wx-m6969421.jpg?yt-v=20230518"
              alt=""
            />
            <div class="c-tip">报课及更多课程详情请扫码咨询课程顾问</div>
          </div>
          <div @click="consultShow = false" class="confirm-btn">确定</div>
        </div>
      </div>
    </div>

    <div v-if="isPhone" class="bottom-nav">
      <div @click="consultPop" class="consult-btn">咨询更多</div>
    </div>
  </div>
</template>

<script>
import ajax from "./../../api/ajax";
import Head from "./../../components/Head";
export default {
  name: "Curriculum-detail",
  components: {
    Head
  },
  data() {
    return {
      wx: "m6969421",
      isPhone: false,
      consultShow: false,
      currentIndex: 1,
      detailData: [
        [
          // "/static/img/2021-08-06/zyb/img-1.jpg",
          // "/static/img/2021-08-06/zyb/img-2.jpg",
          // "/static/img/2021-08-06/zyb/img-3.jpg",
          // "/static/img/2021-08-06/zyb/img-4.jpg",
          // "/static/img/2021-08-06/zyb/img-5.jpg",
          // "/static/img/2021-08-06/zyb/img-6.jpg",
          // "/static/img/2021-08-06/zyb/img-7.jpg",
          // "/static/img/2021-08-06/zyb/img-8.jpg"
        ],
        [
          "/static/img/qkb/1.jpg",
          "/static/img/qkb/2.jpg",
          "/static/img/qkb/3.jpg",
          "/static/img/qkb/4.jpg",
          "/static/img/qkb/5.jpg",
          "/static/img/qkb/6.jpg",
          "/static/img/qkb/7.jpg",
          "/static/img/qkb/8.jpg"
        ],
        [
          "/static/img/ccb/1.jpg",
          "/static/img/ccb/2.jpg",
          "/static/img/ccb/3.jpg",
          "/static/img/ccb/4.jpg",
          "/static/img/ccb/5.jpg",
          "/static/img/ccb/6.jpg",
          "/static/img/ccb/7.jpg",
          "/static/img/ccb/8.jpg"
        ],
        [
          // "/static/img/1v1/1.jpg",
          // "/static/img/1v1/2.jpg",
          // "/static/img/1v1/3.jpg",
          // "/static/img/1v1/4.jpg",
          // "/static/img/1v1/5.jpg",
          // "/static/img/1v1/6.jpg",
          // "/static/img/1v1/7.jpg",
          // "/static/img/1v1/8.jpg"
        ]
      ],
      qualityCourse: [
        {
          id: 1,
          name: "全科基础班",
          title: ["基础薄弱适用", "三阶段课程提升英语核心力"],
          img: "/static/img/ielts_1.png"
        },
        {
          id: 2,
          name: "全科训练营",
          title: ["魔鬼训练营", "1vs1式全程督学", ""],
          img: "/static/img/ielts_2.png"
        },
        {
          id: 3,
          name: "全科冲刺班",
          title: [
            "实用的技巧集训",
            "全程小班直播互动",
            "将你的基本功转化成分数!"
          ],
          img: "/static/img/ielts_3.png"
        },
        {
          id: 4,
          name: "1V1规划班",
          title: [
            "针对弱项量身设置课程内容",
            "根据吸收程度调节授课节奏",
            "公认效率喜人的学习形式!"
          ],
          img: "/static/img/ielts_4.png"
        }
      ]
    };
  },
  methods: {
    consultPop() {
      this.consultShow = true;
    }
  },
  computed: {
    recommendData() {
      const id = this.currentIndex.toString();
      switch (id) {
        case "1":
          return [this.qualityCourse[1], this.qualityCourse[3]];
          break;
        case "2":
          return [this.qualityCourse[2], this.qualityCourse[3]];
          break;
        case "3":
          return [this.qualityCourse[1], this.qualityCourse[3]];
          break;
        case "4":
          return [this.qualityCourse[1], this.qualityCourse[2]];
          break;
        default:
          break;
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    this.currentIndex = to.query.id || 1;
    next();
  },
  mounted() {
    if (document.body.clientWidth <= 750) {
      this.isPhone = true;
    }
    this.currentIndex = this.$route.query.id || 1;
  }
};
</script>

<style lang="stylus" scoped>
.content {
  width: 100%;
  height: 100%;
  padding: 120px 0 50px;
  background-color: #f5f7fa;

  .content-wrap {
    max-width: 1200px;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    align-items: flex-start;

    .consult-content {
      text-align: center;

      img {
        width: 220px;
        height: 220px;
      }

      .c-wx {
        font-family:"思源黑体";
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333333;
      }

      .c-tip {
        font-family:"思源黑体";
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        letter-spacing: 0px;
        color: #333333;
      }
    }

    .head-title {
      font-family:"思源黑体";
      font-size: 18px;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0px;
      color: #333333;
      border-bottom: 1px solid #e6e6e6;
      padding-bottom: 25px;
      margin-bottom: 25px;
    }

    .img-item {
      width: 800px;
    }

    .block {
      background-color: #ffffff;
      box-shadow: 0px 2px 6px 0px rgba(30, 45, 97, 0.06);
      border-radius: 6px;
    }

    .c-detail {
      margin-right: 20px;
      padding: 30px 24px;
      flex: 1;
    }

    .c-right {
      flex: 1;
    }

    .c-consult {
      padding: 30px 20px;
      margin-bottom: 20px;
    }

    .c-recommend {
      padding: 23px 20px;

      .course-list {
        display: flex;
        flex-flow: column;
        align-items: center;

        .c-more {
          border-top: 1px solid #f2f2f2;
          padding: 10px 20px;
          display: block;
          font-family:"思源黑体";
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #7d5fe6;
        }

        .c-item {
          width: 260px;
          background-color: #ffffff;
          box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.04);
          border-radius: 2.5px;
          cursor: pointer;
          margin-bottom: 20px;
        }

        .card-img {
          transition: all 0.3s ease;
        }

        .card-img:hover {
          margin-top: -30px;
        }

        .c-title {
          font-family:"思源黑体";
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 24px;
          letter-spacing: 0px;
          color: #333333;
        }

        .c-name {
          font-family:"思源黑体";
          font-size: 20px;
          font-weight: 700;
          font-stretch: normal;
          letter-spacing: 4px;
          color: #333333;
          margin-bottom: 10px;
        }

        .c-txt {
          display: flex;
          flex-flow: column;
          justify-content: center;
          align-items: center;
          margin: 20px 0;
        }
      }
    }
  }
}

.mask {
  width: 100%;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pop {
  padding: 20px 10px;
  width: 60%;
  text-align: center;
  background-color: #ffffff;
  box-shadow: 0px 1px 3px 0px rgba(30, 45, 97, 0.06);
  border-radius: 5px;

  .confirm-btn {
    width: 60%;
    margin: 10px auto 0;
    padding: 7px 0;
    background-color: #1376f8;
    box-shadow: 0px 3px 5px 0px rgba(19, 118, 248, 0.24);
    border-radius: 20px;
    font-family:"思源黑体";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #ffffff;
  }

  .pop-title {
    font-family:"思源黑体";
    font-size: 15px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #333333;
  }

  .pop-wximg {
    width: 80%;
  }

  .c-wx {
    font-family:"思源黑体";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #333333;
  }

  .c-tip {
    font-family:"思源黑体";
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 0px;
    color: #333333;
  }
}

.bottom-nav {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background: #fff;
  padding: 12px 0;

  .consult-btn {
    cursor: pointer;
    text-align: center;
    width: 80%;
    margin: 0 auto;
    background-color: #ff8817;
    border-radius: 20px;
    font-family:"思源黑体";
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    letter-spacing: 1px;
    color: #ffffff;
    padding: 11px 0;
  }
}

@media only screen and (max-width: 1024px) {
  .content {
    padding: 90px 0;
  }

  .content-wrap {
    width: 90% !important;
  }

  .course-list {
    justify-content: space-around;
    flex-flow: row !important;
  }

  .c-item {
    width: 45% !important;
  }

  .c-more {
    font-size: 9px !important;
  }

  .c-name {
    font-size: 10px !important;
  }

  .c-title {
    width: 90%;
    text-align: center;
    font-size: 7px !important;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .c-right {
    width: 100%;
    margin-top: 10px;
  }

  .c-recommend {
    padding: 15px 10px !important;
  }

  .content-wrap {
    flex-flow: column;
  }

  .c-detail {
    margin-right: 0 !important;
    padding: 15px 10px !important;
  }

  .img-item {
    width: 100% !important;
  }

  .head-title {
    font-size: 12px !important;
    padding-bottom: 15px !important;
    margin-bottom: 10px !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Curriculum/Curriculum-detail.vue